import React, { FC } from 'react';
import s from "../../../pages/text-editor-page/widgets/preview-social-network/LinkedInPostPreview.module.css";
import visibility from "../../../assets/img/visibility.svg";
import { setIsPreviewVisible } from "../../../store/slices/projectSlice";
import { useAppDispatch } from "../../../store/store";
import {useSelector} from "react-redux";
import {selectIsPreviewVisible} from "../../../store/selectors/projectSelectors";

type PreviewButtonProps = { isBackground: boolean };

const PreviewButton: FC<PreviewButtonProps> = ({ isBackground }) => {
    const dispatch = useAppDispatch();
    const isPreviewVisible=useSelector(selectIsPreviewVisible);
    const togglePreviewVisibility = () => {
        dispatch(setIsPreviewVisible(!isPreviewVisible));
    };
    return (
        <div
            className={isBackground ? s.with_background : s.without_background}
            onClick={togglePreviewVisibility}
        >
            <p className={s.text}>{isPreviewVisible ? 'Hide post' : 'Preview post'}</p>
            <img src={visibility} alt={isPreviewVisible ? "Hide post" : "View post"}/>
        </div>
    );
};

export default PreviewButton;
